// Helpers for persisting AI story data across sessions

export interface AIStoryEssentials {
  pages: { pdf: any[] };
  cover_pages: { pdf: any[] };
  pages_predefined_texts: any[];
  pages_dedication_texts: any[];
  cover_pages_predefined_texts: any[];
  cover_pages_dedication_texts: any[];
  status: string | undefined;
  timestamp: number;
}

export const saveAIStoryData = (uuid: string, data: any): void => {
  try {
    const essentials: AIStoryEssentials = {
      pages: { pdf: data?.pages?.pdf || [] },
      cover_pages: { pdf: data?.cover_pages?.pdf || [] },
      pages_predefined_texts: data?.pages_predefined_texts || [],
      pages_dedication_texts: data?.pages_dedication_texts || [],
      cover_pages_predefined_texts: data?.cover_pages_predefined_texts || [],
      cover_pages_dedication_texts: data?.cover_pages_dedication_texts || [],
      status: data?.status,
      timestamp: Date.now(),
    };
    localStorage.setItem(`aiStoryData-${uuid}`, JSON.stringify(essentials));
  } catch (e) {
    console.error('Error saving AI story data:', e);
  }
};

export const loadAIStoryData = (uuid: string): any | null => {
  try {
    const raw = localStorage.getItem(`aiStoryData-${uuid}`);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const mergeAIStoryWithDefault = (aiData: any, defaultData: any): any => {
  if (!aiData) return defaultData;
  if (!defaultData) return aiData;

  const merged = JSON.parse(JSON.stringify(defaultData));

  if (aiData.pages_predefined_texts) {
    aiData.pages_predefined_texts.forEach((aiPage: any) => {
      if (aiPage.ai_generated && aiPage.image) {
        const pageNum = parseInt(aiPage.page);
        if (!isNaN(pageNum) && pageNum >= 0 && pageNum < merged.pages.pdf.length) {
          merged.pages.pdf[pageNum] = aiPage.image;
        }
      }
    });
  }

  if (aiData.cover_pages_predefined_texts) {
    aiData.cover_pages_predefined_texts.forEach((aiCover: any) => {
      if (aiCover.ai_generated && aiCover.image) {
        const coverNum = parseInt(aiCover.page);
        if (!isNaN(coverNum) && coverNum >= 0 && coverNum < merged.cover_pages.pdf.length) {
          merged.cover_pages.pdf[coverNum] = aiCover.image;
        }
      }
    });
  }

  return merged;
};
